var nargs = /\{([0-9a-zA-Z_]+)\}/g;

/**
 * https://github.com/Matt-Esch/string-template/blob/v1.0.0/index.js
 *
 * @param {string} msg
 * @returns {string}
 */
export default function template(msg) {
  var args;

  if (arguments.length === 2 && typeof arguments[1] === 'object') {
    args = arguments[1];
  } else {
    args = new Array(arguments.length - 1);
    for (var i = 1; i < arguments.length; ++i) {
      args[i - 1] = arguments[i];
    }
  }

  if (!args || !args.hasOwnProperty) {
    args = {};
  }

  return msg.replace(nargs, function (match, i, index) {
    var result;

    if (msg[index - 1] === '{' && msg[index + match.length] === '}') {
      return i;
    }
    result = Object.prototype.hasOwnProperty.call(args, i) ? args[i] : null;
    result = result ?? '';

    return result;
  });
}
